// errors that are only used internally within the web client; the server doesn't know about these
export const NOT_AUTHENTICATED = -1;
export const SERVER_ERROR = -2;
export const NETWORK_ERROR = -3;
export const FORBIDDEN = -4;
export const NOT_FOUND = -5;
export const BAD_REQUEST = -6;
export const NOT_AUTHORIZED = -7;
